import React from 'react';
import { Box, TextInput, Group, ActionIcon, Divider } from '@mantine/core';
import { X, Plus } from 'tabler-icons-react';
import { parseNumber } from '../../utils/numberUtils';

function OrderEpreuve({ form, index, onRemove, type }) {
    const title = type === 'oc'
        ? "Mettre dans l'ordre croissant les nombres"
        : "Mettre dans l'ordre decroissant les nombres";

    // Function to validate input
    const validateInput = (value) => {
        if (!value) return false; // no empty values
        const number = parseNumber(value);
        if (number === null) return false;

        // Check for duplicates
        const currentValues = form.values.epreuves[index].consigne
            .map(v => parseNumber(v))
            .filter(v => v !== null);

        const duplicates = currentValues.filter(v => v === number);
        if (duplicates.length > 1) return false;

        return true;
    };

    // Function to handle input change
    // Function to handle input change
    const handleInputChange = (value, idx) => {
        // Allow partial typing: "-", "1", "1.", "1/", "-1/2", etc.
        const partialPattern = /^-?\d*(?:[./]\d*)?$/;

        if (partialPattern.test(value)) {
            form.setFieldValue(`epreuves.${index}.consigne.${idx}`, value);
        }
    };

    return (
        <Box key={index}>
            <TextInput
                placeholder={title}
                mb={10}
                radius={10}
                {...form.getInputProps(`epreuves.${index}.titre`)}
            />
            <Group position="apart">
                <Group>
                    {form.values.epreuves[index].consigne.map((item, idx) => (
                        <TextInput
                            key={idx}
                            type="text"
                            value={item}
                            onChange={(e) => handleInputChange(e.target.value, idx)}
                            radius={10}
                            w={80}
                            placeholder="Nombre"
                            error={!validateInput(item)}
                        />
                    ))}
                    <ActionIcon
                        color="green"
                        onClick={() => {
                            if (form.values.epreuves[index].consigne.length < 10) {
                                form.insertListItem(`epreuves.${index}.consigne`, "");
                            }
                        }}
                    >
                        <Plus size="1rem" />
                    </ActionIcon>
                </Group>
                <ActionIcon color="red" onClick={() => onRemove(index)}>
                    <X size="1rem" />
                </ActionIcon>
            </Group>
            <Divider my={20} />
        </Box>
    );
}

export default OrderEpreuve; 